/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiDrop } from '../models/ApiDrop';
import { ApiDropVote } from '../models/ApiDropVote';
import { HttpFile } from '../http/http';

export class ApiDropAndDropVote {
    'drop': ApiDrop;
    'vote': ApiDropVote;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "drop",
            "baseName": "drop",
            "type": "ApiDrop",
            "format": ""
        },
        {
            "name": "vote",
            "baseName": "vote",
            "type": "ApiDropVote",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiDropAndDropVote.attributeTypeMap;
    }

    public constructor() {
    }
}

